import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function InvMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    )
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">Investigation</h5>

            <div className="row">

                <MenuCard link="/add-radio" title="Add Investigation" icon="fa-solid fa-x-ray" color="#0d6efd"/>

                <MenuCard link="/start-dicom" title="Dicom Service Start" icon="fa-solid fa-play" color="#20c997"/>

                <MenuCard link="https://pacs.mgmebuild.com/ohif/" title="View Dicom" icon="fa-solid fa-images"
                          color="#6f42c1"/>

                <MenuCard link="/inv-view" title="Investigation Entry" icon="fa-solid fa-file-medical" color="#fd7e14"/>

                <MenuCard link="/inv-files-view" title="View File Upload" icon="fa-solid fa-file-arrow-up"
                          color="#dc3545"/>

                <MenuCard link="/collection-inv" title="Collection Report" icon="fa-solid fa-chart-line"
                          color="#198754"/>

            </div>

        </section>
    )
}
export default InvMenu;